{
  "error": "오류",
  "help": "도움말",
  "info": "정보",
  "success": "성공",
  "warning": "경고"
}
